import React, { Fragment, ReactNode } from 'react';
import { Helmet } from 'react-helmet';

export type DlsWrapperProps = {
  children: ReactNode;
  dlsUrl: string;
};

export type DlsWrapperDyanmicProps = {
  children: ReactNode;
};
export const DlsWrapper = ({ children, dlsUrl }: DlsWrapperProps) => (
  <Fragment>
    <Helmet>
      <link rel="stylesheet" href={dlsUrl} />
    </Helmet>
    {children}
  </Fragment>
);

export const Dls6Wrapper = ({ children }: DlsWrapperDyanmicProps) => (
  <DlsWrapper dlsUrl="https://www.aexp-static.com/cdaas/one/statics/@americanexpress/dls/6.25.5/package/dist/6.25.5/styles/dls.min.css">
    {children}
  </DlsWrapper>
);

export const Dls7Wrapper = ({ children }: DlsWrapperDyanmicProps) => (
  <DlsWrapper dlsUrl="https://www.aexp-static.com/cdaas/dls/packages/@americanexpress/dls/7.0.0/stylesheets/dls-max.min.css">
    {children}
  </DlsWrapper>
);
